import React from 'react';
import { Button, Modal, Tooltip } from 'antd';
//import connect, {appendAuthorizationHeader} from '../../utils/connector/api-connector';
import { ContactForm } from '../../forms/ContactForm';
import IpForm, { ModalDataI } from '../../forms/IpForm';

import Request from '../../model/Request';
import { ButtonIcon } from '../icons';
// import { rootAPI } from '../../constants/globals';
import Flex from '../StyledComponents/Flex';
import StyledLink from '../StyledComponents/StyledLink';
import { Actions, Subjects } from '../../configuration/permission/ability';
import { hasRole, isNullOrUndefined } from '../../utils';
import { useTranslation } from '@nic-react-i18n/core';
import { useKeycloak } from '@nic-react/auth';
import { useLocation, useNavigate } from 'react-router';
import { AbilityContext } from '../../context/Authorization';
import dayjs from 'dayjs';

enum ModalChoice {
    ContactForm,
    IpForm,
    NoForm
}

interface RequestActionInterface {

    request: Request;
    /*
    putContactResponse: any;
    putIpResponse: any;
    updateContact: ( formFields: string ) => any;
    updateIp: ( formFields: string ) => any;

     */
}
/*
interface ActionInfo {
    title: string;
    icon: string;
    readOnly?: boolean;
    disabled?: boolean;
    action: () => void;
}
*/
type RequestActionProps = RequestActionInterface;

const RequestAction: React.FC<RequestActionProps> = (props) => {

    const [showModal, setShowModal] = React.useState(false)
    const [modal, setModal] = React.useState(ModalChoice.NoForm)
    const [spinning] = React.useState(false)
    //const [plusSelected, setPlusSelected] = React.useState(false)
    //const [editSelected, setEditSelected] = React.useState(false)
    const [readOnly, setReadyOnly] = React.useState(false)
    const [modalHasError, setModalHasError] = React.useState(false)
    const [modalError, setModalError] = React.useState('')

    const [ipAddress, setIpAddress] = React.useState(props.request.ipAddress)
    const [contact, setContact] = React.useState(props.request.contact)

    const {keycloak} = useKeycloak()

    const {t} = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()
    const capability = React.useContext(AbilityContext)

    const handleCancel = (data?: ModalDataI) => {
        if (data !== undefined) {
            if (data.ip !== undefined) {
                setIpAddress(data.ip)
            }
            if (data.contact !== undefined) {
                setContact(data.contact)
            }
        }

        setShowModal(false);
    }


    const hasBookAction = () => {
        const {request} = props;
        let hasBookingAction = false;
        const bookingLink = 'action:book';
        if (request) {
            const origLinks = request.links;
            if (!isNullOrUndefined(origLinks)) {
                hasBookingAction = !isNullOrUndefined(origLinks[bookingLink]);
            }
        }
        return hasBookingAction;
    }

    const renderNoData = () => {

        return (
            <Flex
                direction={'column'}
                justify={'center'}
                align={'center'}
            >
                <div
                    style={{color: 'orange', fontSize: '2em'}}
                >
                    <i className={'fal fa-ban'}/>
                </div>
                <div>
                    {t('form.nodata')}
                </div>
                <Flex
                    direction={'row'}
                    justify={'flex-end'}
                    align={'center'}
                    style={{
                        width: '100%',
                        paddingTop: '15px',
                        marginTop: '20px',
                        borderTop: '1px dashed #e9e9e9'
                    }}
                >
                    <Button size={'small'} onClick={() => {handleCancel(); }}>Annulla</Button>
                </Flex>

            </Flex>
        );
    }

    const renderModal = () => {

        let modalComponent = null;
        let modalTitle = null;
        switch ( modal ) {
            case ModalChoice.ContactForm: {
                modalTitle = (
                    <div>
                        <span><i className={'fal  fa-address-card'}/></span>
                        <span  style={{paddingLeft: '10px'}}>{t('modal.contact.title')}</span>
                    </div>
                );
                if (
                    (
                        capability.can(Actions.UPDATE, Subjects.CONTACT)  ||
                        capability.can(Actions.VIEW, Subjects.CONTACT )
                    ) &&
                    (!isNullOrUndefined(contact) || !readOnly)
                ) {
                    modalComponent = (
                        <ContactForm
                            errorInfo={{hasError: modalHasError, errorMsg: modalError}}
                            contact={contact}
                            loading={spinning}
                            readOnly={readOnly}
                            handleCancel={handleCancel}
                        />
                    );
                } else {
                    modalComponent = renderNoData();
                }
                break;
            }
            case ModalChoice.IpForm: {

                modalTitle = (
                    <div>
                        <span><i className={'fal  fa-globe'}/></span>
                        <span  style={{paddingLeft: '10px'}}>{t('modal.ipAddress.title')}</span>
                    </div>
                );
                if (!isNullOrUndefined(ipAddress) || !readOnly) {
                    modalComponent = (
                        <IpForm
                            errorInfo={{hasError: modalHasError, errorMsg: modalError}}
                            ipAddress={ipAddress}
                            loading={spinning}
                            readOnly={readOnly}
                            handleCancel={handleCancel}
                        />
                    );
                } else {
                    modalComponent = renderNoData();
                }
                break;
            }
            default:
                break;
        }

        return (
            <Modal
                title={modalTitle}
                open={showModal}
                footer={null}
                closable={false}
                onCancel={() => {setModalError( ''); setModalHasError( false); }}
            >
                {modalComponent}

            </Modal>
        );
    }
/*
    const checkPutAction = (action: any, prevAction: any, onSuccess: (value: any) => void) => {
        // console.log('CheckPutAction: ', action);
        if (action) {
            if (changedPostStatus(action, prevAction)) {
                if (action.pending) {
                    setModalHasError( false);
                    setSpinning( true);
                } else {
                    if (action.rejected) {
                        setSpinning( false);
                        // console.log('Error: ', action);
                        setModalError(action.reason.cause.message)
                        setModalHasError(true);
                    } else {
                        if (action.fulfilled) {
                            setSpinning( false);
                            setModalHasError( false);
                            // console.log('CHECKPUTACTION: ', action.value);
                            onSuccess(action.value);
                        }
                    }
                }
            }
        }
    }
 */
/*
    React.useEffect(() => {
        const {request} = props;
        checkPutAction(putContactResponse, props.putContactResponse, (value: any) => {

            let requestObj: Request = new Request();

            requestObj.clone(request);
            requestObj.contact = value.contact;

            // this.setState({request: requestObj});
            setShowModal(false)
            notification.success({
                message: t('notification.contact.title'),
                description: t('notification.contact.success')
            });
            let url = parse(location.pathname + location.search, true);
            navigate(url.pathname + '?request=' + url.query.request);
        });

        checkPutAction(putIpResponse, props.putIpResponse, (value: any) => {
            let requestObj: Request = new Request();
            requestObj.clone(request);
            requestObj.ipAddress = value.ipAddress;
            setShowModal( false);

            notification.success({
                message: t('notification.ip.title'),
                description: t('notification.ip.success')
            });

            let url = parse(location.pathname + location.search, true);
            navigate(url.pathname + '?request=' + url.query.request);
        });
    }, [props])
*/
/*
 const buildActionButtons = (actions: Array<ActionInfo>) => {
        let actionButtons: Array<React.ReactElement<any>> = [];

        actions.forEach((action: ActionInfo, i: number) => {
            actionButtons.push(
                <div key={i} style={{paddingTop: '10px'}}>
                    <Tooltip title={action.title} placement={'left'}>
                        <Button
                            disabled={action.disabled}
                            type={'primary'}
                            shape={'circle'}
                            onClick={() => {
                                action.action();
                            }}
                        >
                            <i className={action.icon}/>
                        </Button>
                    </Tooltip>
                </div>
            );
        });

        return (
            <span>
                {actionButtons}
            </span>
        );
    }
*/
    const {request} = props;

    let _modal = null;
    if (showModal) {
        _modal = renderModal();
    }
    let isRegistryOperator: boolean = (keycloak.realm === 'registry') && hasRole(keycloak, 'tech');

    let contactDefined: boolean =
        capability.can(Actions.VIEW, Subjects.CONTACT) && !isNullOrUndefined(request.contact);

    let hasSuccededDate = ! isNullOrUndefined(request.succededDate);
    let isFailed = (request.status === 'failed');
    let contactAction: string =
        isRegistryOperator || hasSuccededDate || isFailed ? 'view' : (contactDefined ? 'edit' : 'new');


    let ipDefined: boolean =
        capability.can(Actions.VIEW, Subjects.IP) && !isNullOrUndefined(request.ipAddress);

    //console.log('ipDefined: ',  ipDefined, request.ipAddress)
    //console.log('IP Capability ', 'view: ', capability.can(Actions.VIEW, Subjects.IP), ' update: ', capability.can(Actions.UPDATE, Subjects.IP), ipDefined, isRegistryOperator)

    let ipAction: string = (
        !capability.can(Actions.UPDATE, Subjects.IP) ||
        isRegistryOperator ||
        hasSuccededDate ||
        isFailed ?
            'view' :
            (ipDefined ? 'edit' : 'new')
    );


   // console.log('IP Capability ', 'view: ', capability.can(Actions.VIEW, Subjects.IP), ' update: ', capability.can(Actions.UPDATE, Subjects.IP), ipDefined, ipAction)

    let ipObject = {
        title: t(`request.ip.${ipAction}`),
        disabled: (
            (
                ! capability.can(Actions.VIEW, Subjects.IP) ||
                (
                    capability.can(Actions.VIEW, Subjects.IP) &&
                    request.ipAddress === undefined
                )
            ) &&
            ! capability.can(Actions.UPDATE, Subjects.IP)
        ),
        readOnly: hasSuccededDate,
        action: () => {

           // console.log('IPAction')

            setShowModal((
                capability.can(Actions.UPDATE, Subjects.IP)
            ) || (
                capability.can(Actions.VIEW, Subjects.IP) &&
                ( request.ipAddress !== undefined )
            ))
            setModal(ModalChoice.IpForm)
            setReadyOnly(!capability.can(Actions.UPDATE, Subjects.IP) ||
                (hasSuccededDate || isRegistryOperator || (request.status === 'failed')))

        },
        icon: 'fal fa-globe',
    };

    let contactObject = {
        title: t(`request.contact.${contactAction}`),
        disabled: (
            (
                ! capability.can(Actions.VIEW, Subjects.CONTACT) ||
                (
                    capability.can(Actions.VIEW, Subjects.CONTACT) &&
                    request.contact === undefined
                )
            ) &&
            ! capability.can(Actions.UPDATE, Subjects.CONTACT)
        ),
        contactObject: hasSuccededDate,
        action: () => {
            setShowModal(capability.can(Actions.UPDATE, Subjects.CONTACT)
                || (
                    capability.can(Actions.VIEW, Subjects.CONTACT) &&
                    ( request.contact !== undefined )))
            setModal(ModalChoice.ContactForm)
            setReadyOnly(!capability.can(Actions.UPDATE, Subjects.CONTACT) ||
                hasSuccededDate || isRegistryOperator || (request.status === 'failed'))
        },
        icon: 'fal fa-user-alt',
    };

    let ipIconColor = (ipDefined ? 'green' : '#e20000') ;
    let contactIconColor = (contactDefined ? 'green' : '#e20000');

    let bookingDefined = (
        capability.can(Actions.UPDATE, Subjects.BOOKING) &&
        contactDefined &&
        ipDefined &&
        hasBookAction()
    );

    let bookingObject = {
        title: t('request.book'),
        icon: 'fal fa-calendar',
        disabled: ( !bookingDefined ),
        action: () => {
            // console.log('BOOKING: ', this.props.location);
            const {pathname} = location;
            let now = dayjs();
            //let action = {action: 'book', year: now.year(), month: now.month() + 1};
            //let query: Record<string, any> = {...url.query, ...action};
            // console.log('REQUEST-BOOK: ', query);
            let fullPath = pathname;
            //let keys = Object.keys(query);
            /*let i;
            for (i = 0; i < keys.length - 1; i++) {
                fullPath += keys[i] + '=' + query[keys[i]] + '&';
            }
            */

            fullPath += `/calendar/month/${now.year()}/${now.month()+1}`;
            navigate(fullPath);
        }
    };

   // console.log('----> ', ipObject.disabled)

    return (
        <Flex
            direction={'row'}
            justify={'space-between'}
            align={'center'}
            style={{
                fontSize: 'smaller',
                fontWeight: 500,

            }}
        >
            {_modal}
            <StyledLink
                cursor={(ipObject.disabled ? 'not-allowed' : 'pointer')}
            >
            <Tooltip title={ipObject.title}>
                <div

                    onClick={() => {
                       // console.log('--- click---')
                        setModalHasError( false)
                        setModalError( '')
                        ipObject.action();
                    }}
                >
                    <ButtonIcon
                        size={'2rem'}
                        icon={'fa-globe'}
                        solid={true}
                        color={ipIconColor}
                        mask={'fa-square'}
                        shrink={7}
                    />
                </div>
            </Tooltip>
            </StyledLink>
            <StyledLink
                paddingLeft={'10px'}
                cursor={(contactObject.disabled ? 'not-allowed' : 'pointer')}
            >
                <Tooltip title={contactObject.title}>
                    <div
                        onClick={() => {
                            contactObject.action();
                        }}
                    >
                        <ButtonIcon
                            size={'2rem'}
                            icon={'fa-address-card'}
                            solid={true}
                            color={contactIconColor}
                            mask={'fa-square'}
                            shrink={6.5}
                        />
                    </div>
                </Tooltip>
            </StyledLink>
            {!hasSuccededDate &&
                <StyledLink
                    cursor={(bookingObject.disabled ? 'not-allowed' : 'pointer')}
                    paddingLeft={'10px'}>
                <Tooltip title={bookingObject.title}>
                    <div

                        onClick={() => {
                            if (!bookingObject.disabled) {
                                bookingObject.action();
                            }
                        }}
                    >
                        <ButtonIcon
                            size={'2rem'}
                            solid={true}
                            shrink={8}
                            color={(bookingObject.disabled ? 'gray' : 'green')}
                            icon={'fa-calendar-alt'}
                            mask={'fa-square'}
                        />
                    </div>
                </Tooltip>
                </StyledLink>
            }
        </Flex>
    );

}

export default RequestAction
/*
let connect((props: any): any => {

    if (props.token && props.token.authenticated) {

        const {pathname, search} = props.location;
        const [rootAPI] = AppConf.getRootUrl(props.token.realm ? props.token.realm : '');
        // console.log('useHateoas: ', useHateoas);

        let url = parse(pathname + search, true);

        let requestId = url.query.request;
        return ({
            updateContact: (formFields: string) => {
                return ( {
                        putContactResponse: {
                            url: `${rootAPI}${pathname}/${requestId}/contact`,
                            method: 'PUT',
                            headers: appendAuthorizationHeader(props).headers,
                            body: formFields
                        }
                    }
                );
            },
            updateIp: (formFields: string) => {
                return ({
                    putIpResponse: {
                        url: `${rootAPI}${pathname}/${requestId}/ipAddress`,
                        method: 'PUT',
                        headers: appendAuthorizationHeader(props).headers,
                        body: formFields
                    }
                });
            }
        });
    }
})
*/